export default "__VITE_ASSET__gOnlbS3Cmxji$pdZZMY03g__"